'use client'

import React, { useEffect, useState } from 'react';
import { AlertDialog, AlertDialogAction, AlertDialogContent, AlertDialogDescription, AlertDialogFooter, AlertDialogHeader, AlertDialogTitle } from "@/components/ui/alert-dialog";
import { RefreshCw } from "lucide-react";

// Fonction pour détecter si l'app est en mode PWA
const isPWA = () => {
    return window.matchMedia('(display-mode: standalone)').matches ||
        window.navigator.standalone || // Pour iOS
        document.referrer.includes('android-app://');
};

const useVersionCheck = (currentVersion) => {
    const [needsUpdate, setNeedsUpdate] = useState(false);

    useEffect(() => {
        const checkVersion = async () => {
            try {
                const response = await fetch('/version.json?' + Date.now());
                const { version } = await response.json();
                console.log(version, currentVersion);

                if (version !== currentVersion) {
                    console.log('Une nouvelle version est disponible', version, currentVersion);
                    setNeedsUpdate(true);
                }
            } catch (error) {
                console.log(error, 'Erreur lors de la vérification de la version:', error);
            }
        };

        checkVersion();
        const interval = setInterval(checkVersion, 60 * 1000 * 5);
        return () => clearInterval(interval);
    }, [currentVersion]);

    return needsUpdate;
};

const UpdatePrompt = ({ version }) => {
    const needsUpdate = useVersionCheck(version);
    const [isOpen, setIsOpen] = useState(false);
    const [isPWAMode, setIsPWAMode] = useState(false);

    useEffect(() => {
        setIsPWAMode(isPWA());
        setIsOpen(needsUpdate);
    }, [needsUpdate]);

    const handleUpdate = () => {
        if (isPWAMode) {
            // Pour les PWA, on ferme juste la dialogue car l'utilisateur doit fermer/rouvrir l'app
            setIsOpen(false);
        } else {
            // Pour le navigateur web normal, on peut faire un refresh
            window.location.reload();
        }
    };

    const getUpdateInstructions = () => {
        if (isPWAMode) {
            return "Pour mettre à jour l'application, veuillez la fermer complètement (la retirer du multitâche) puis la relancer.";
        }
        return "Veuillez rafraîchir la page pour obtenir les dernières fonctionnalités.";
    };

    const getButtonText = () => {
        if (isPWAMode) {
            return "J'ai compris";
        }
        return "Mettre à jour maintenant";
    };

    return (
        <AlertDialog open={isOpen}>
            <AlertDialogContent className="max-w-md">
                <AlertDialogHeader>
                    <AlertDialogTitle className="flex items-center gap-2">
                        <RefreshCw className="h-5 w-5" />
                        Mise à jour disponible
                    </AlertDialogTitle>
                    <AlertDialogDescription>
                        {getUpdateInstructions()}
                    </AlertDialogDescription>
                </AlertDialogHeader>
                <AlertDialogFooter>
                    <AlertDialogAction onClick={handleUpdate} className="w-full">
                        {getButtonText()}
                    </AlertDialogAction>
                </AlertDialogFooter>
            </AlertDialogContent>
        </AlertDialog>
    );
};

export default UpdatePrompt;